import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportEstimateView,
    EstimateClient,
    GetEstimateColumnChartValuesResultType,
    GetEstimateLineChartValuesResultType,
    GetEstimateMetricsValuesResultType,
    GetEstimateValuesParameters,
    GetEstimateValuesResultType,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class BidEstimateService extends CustomReportServiceBase<EstimateClient, CustomReportEstimateView> {
    constructor(protected override client: EstimateClient) {
        super(client);
    }

    async getEstimateValues(parameters: GetEstimateValuesParameters): Promise<GetEstimateValuesResultType[]> {
        return await lastValueFrom(this.client.estimateGetEstimateValues(parameters));
    }

    async getEstimateBoxesValues(parameters: GetEstimateValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.estimateGetEstimateBoxesValues(parameters));
    }

    async getEstimateColumnChartValues(
        parameters: GetEstimateValuesParameters
    ): Promise<GetEstimateColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.estimateGetEstimateColumnChartValues(parameters));
    }

    async getEstimateMetricsValues(
        parameters: GetEstimateValuesParameters
    ): Promise<GetEstimateMetricsValuesResultType> {
        return await lastValueFrom(this.client.estimateGetEstimateMetricsValues(parameters));
    }

    async getEstimateLineChartValues(
        parameters: GetEstimateValuesParameters
    ): Promise<GetEstimateLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.estimateGetEstimateLineChartValues(parameters));
    }

    override async saveCustomReport(body: CustomReportEstimateView): Promise<CustomReportEstimateView> {
        if (body.isPublic) return await lastValueFrom(this.client.estimateSaveCatalogReport(body));
        else return await lastValueFrom(this.client.estimateSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportEstimateView> {
        return await lastValueFrom(this.client.estimateGetCustomReport(id));
    }

    override async shareReport(body: CustomReportEstimateView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.estimateCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportEstimateView> {
        return await lastValueFrom(this.client.estimateGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.estimateResultAvailableColumns(organizationIds));
    }
}
